import { store } from "../../store";
import appConfig from "./../../appconfig";
import * as mutationTypes from "../../store/mutation-types";
import RedirectHelper from "../../components/UtilityComponents/RedirectHelper.vue";
import * as IdpHelper from "../../helper/IdpHelper";

// components
const HomeWrapper = () => import("../../components/ShopComponents/gt2/HomeWrapper-gt2");
const ProductCatalog = () => import("../../components/ShopComponents/gt2/ProductCatalog/ProductCatalogWrapper-gt2");
const ShoppingCart = () => import("../../components/ShopComponents/gt2/ShoppingCart/ShoppingCartWrapper-gt2");
const FullBasketCheckout = () => import("../../components/ShopComponents/gt2/ShoppingCart/FullBasketCheckout-gt2");
const Payment = () => import("../../components/ShopComponents/gt2/Payment-gt2");
const PendingOrderWrapper = () => import("../../components/ShopComponents/gt2/PendingOrder/PendingOrderWrapper-gt2");
const GlobalShopSelection = () => import("../../components/ShopComponents/gt2/ShopSelection/GlobalShopSelection-gt2");
const ProfilePage = () => import("../../components/ShopComponents/gt2/ProfilePage-gt2");
const UserProfilePage = () => import("../../components/ShopComponents/gt2/UserProfilePage-gt2");
const UserDataPage = () => import("../../components/ShopComponents/gt2/UserDataPage-gt2");
const VersionUpdatePage = () => import("../../components/ShopComponents/gt2/VersionUpdate/VersionUpdatePage-gt2");
const GamePage = () => import("../../components/ShopComponents/gt2/DevSupport/GamePage-gt2");
const DevSupport = () => import("../../components/ShopComponents/gt2/DevSupport/DevSupport-gt2");
const Map = () => import("../../components/ShopComponents/gt2/DevSupport/Map-gt2");
const ShoppingCartStepDeliveryMethod = () => import("../../components/ShopComponents/gt2/ShoppingCart/_steps/ShoppingCartStepDeliveryMethod-gt2");
const AddressDeliveryWrapper = () => import("../../components/ShopComponents/gt2/ShoppingCart/_steps/AddressDeliveryWrapper-gt2");
const UserAddressWrapper = () => import("../../components/ShopComponents/gt2/ShoppingCart/_steps/UserAddressWrapper-gt2");
const TableServing = () => import("../../components/ShopComponents/gt2/TableServing-gt2");
const SignUp = () => import("../../components/ShopComponents/gt2/SignUp/SignUp-gt2");
const CheckEmail = () => import("../../components/ShopComponents/gt2/CheckEmail-gt2");
const UserFeedback = () => import("../../components/ShopComponents/gt2/UserFeedback-gt2");
const FeedbackCompleted = () => import("../../components/ShopComponents/gt2/UserFeedbackCompleted-gt2");
const InitializeSubscription = () => import("../../components/ShopComponents/gt2/Subscriptions/InitializeSubscription-gt2");
const SubscriptionPlans = () => import("../../components/ShopComponents/gt2/Subscriptions/SubscriptionPlansWrapper-gt2");
const UserOrdersList = () => import("../../components/ShopComponents/gt2/UserOrders/UserOrdersListWrapper-gt2");
const UserOrderDetails = () => import("../../components/UtilityComponents/UserOrders/UserOrderDetails");
const SubscriptionFinished = () => import("../../components/ShopComponents/gt2/Subscriptions/SubscriptionFinished-gt2");
const AcceptSubscriptionTerms = () => import("../../components/ShopComponents/gt2/Subscriptions/AcceptSubscriptionTerms-gt2");
const AcceptSunsetPointsTerms = () => import("../../components/ShopComponents/gt2/Subscriptions/AcceptSunsetPointsTerms-gt2");
const TradingConditions = () => import("../../components/ShopComponents/gt2/Tenants/TradingConditionsTid6-gt2.vue");
const SubscriptionPlanCancel = () => import("../../components/ShopComponents/gt2/Subscriptions/State/SubscriptionPlanCancel-gt2");
const SubscriptionCancelFeedback = () => import("../../components/ShopComponents/gt2/Subscriptions/State/SubscriptionCancelFeedback-gt2");
const SubscriptionPaymentFailed = () => import("../../components/ShopComponents/gt2/Subscriptions/SubscriptionPaymentFailed-gt2");
const SubscriptionPaymentDone = () => import("../../components/ShopComponents/gt2/Subscriptions/SubscriptionPaymentDone-gt2");
const AboutSunsetToGo = () => import("../../components/ShopComponents/gt2/AboutSunsetToGo-gt2");
const SubscriptionInvoices = () => import("../../components/ShopComponents/gt2/Subscriptions/SubscriptionInvoices-gt2");
const CatalogPagePreview = () => import("../../components/ShopComponents/gt2/CatalogPagePreview-gt2");
const ShoppingCartDriveInBoothNumber = () => import("../../components/ShopComponents/gt2/ShoppingCart/ShoppingCartDriveInBoothNumber-gt2");
const ShoppingCartDriveInDetailsViaQrCode = () => import("../../components/ShopComponents/gt2/ShoppingCart/ShoppingCartDriveInDetailsViaQrCode-gt2");
const ShoppingCartEatInDetailsViaQrCode = () => import("../../components/ShopComponents/gt2/ShoppingCart/ShoppingCartEatInDetailsViaQrCode-gt2");
const CountryLanguageSelectionScreen = () => import("../../components/ShopComponents/gt2/CountryLanguageSelectionScreen-gt2");
const NutritionalInformation = () => import("../../components/ShopComponents/defaultGlobalTemplate/NutritionalInformation.vue");
const UserNotificationsListPage = () => import("../../components/UtilityComponents/UserNotifications/UserNotificationsListPage.vue");
const UserNotificationDetailsPage = () => import("../../components/UtilityComponents/UserNotifications/UserNotificationDetailsPage.vue");
const FriendInvitePage = () => import("../../components/ShopComponents/gt2/FriendInvite-gt2");
const UserReorderList = () => import("../../components/UtilityComponents/UserOrders/UserReorderList.vue");
const MilestoneReward = () => import("../../components/ShopComponents/gt2/MilestoneReward/MilestoneReward-gt2");
const MilestoneRewardDetails = () => import("../../components/ShopComponents/gt2/MilestoneReward/MilestoneRewardDetails.vue");
const Discount = () => import("../../components/ShopComponents/gt2/Discount/Discount.vue");
const CountryLanguage = () => import("../../components/ShopComponents/gt2/CountryLanguage-gt2.vue");
const PointOverview = () => import("../../components/ShopComponents/gt2/Points/PointOverview.vue");
const SubscriptionUpgradeDowngrade = () => import("../../components/ShopComponents/gt2/Subscriptions/SubscriptionUpgradeDowngrade.vue");
const SelectSubscription = () => import("../../components/ShopComponents/gt2/Subscriptions/SelectSubscription.vue");
const SelectPaymentPlan = () => import("../../components/ShopComponents/gt2/Subscriptions/SelectPaymentPlan.vue");
const SubscriptionUpgradeSelectPlan = () => import("../../components/ShopComponents/gt2/Subscriptions/SubscriptionUpgradeSelectPlan.vue");

// handlers
import versionCompare from "../../mobile/versionCompare";
import routeMapper from "../routeMapper";
import { DeliveryMethodsEnum } from "../../domains2/libraries/DeliveryMethods";

const obsoleteVersionRedirect = ({
	pendingUrl = "/pending-order",
	obsoleteUrl = "/obsolete-version",
	successUrl,
	successCallback = () => {}
} = {}) => async (to, from, next) => {
	const isObsoleteVersion = await versionCompare(store);

	const redirect = (path) => {
		if (path) {
			next(path);
		} else {
			next();
		}
	};
	if(
		store.getters.featureToggles.showSunsetPointsTermsPage
		&& store.getters.applicationUserLoggedIn
		&& !store.getters.customerDetails.consents.acceptSunsetPointsTerms) {
		return redirect("/accept-sunsetpoints-terms");
	}
	if (store.getters.hasPendingOrder && !store.getters.retroactivePointsAssignmentPendingOrderId) {
		if(!(from.path === "/pending-order" && to.path === "/subscription-plans")) {
			return redirect(pendingUrl);
		}
	}
	if (store.getters.featureToggles.enableThreeStepFullscreenCheckoutMobile && to.path === "/checkout") {
		return redirect("/full-basket-checkout");
	}

	if (isObsoleteVersion) {
		return redirect(obsoleteUrl);
	}

	const hasAppDownloaded = window.localStorage.getItem("hasAppDownloaded");

	if (
		appConfig.mobile.isMobileApp() &&
		store.getters.featureToggles.enableCountryLanguageSelection &&
		hasAppDownloaded === "0"
	) {
		return redirect({
			name: routeMapper.routeNames.countryLanguageSelectionScreen
		});
	}

	const shopSelected = store.getters.globalSelectedShop;
	const deliveryMethodSelected = localStorage.getItem("deliveryMethodSelected") === "true";
	const applicationUserLoggedIn = store.getters.applicationUserLoggedIn;
	const channel = localStorage.getItem("channel");

	const shopAndDeliveryMethodFlow = async () => {
		/**
		 * If user wants to log in before selecting shop and delivery method
		 */
		if (!applicationUserLoggedIn && (!shopSelected || !deliveryMethodSelected)) {
			await IdpHelper.checkIfUserLoggedIn({
				route: to,
				store,
				idpService: store.getters.serverData.idpService
			});
		}

		if (to.name === routeMapper.routeNames.Home) {
			if (!shopSelected) {
				/**
				 * If shop is not selected, we need to redirect to the shop selection page
				 * before going to the home page
				 */
				return redirect("/shop-selection");
			}

			if (!deliveryMethodSelected) {
				/**
				 * This is because user can log in before selecting delivery method,
				 * so we need to redirect to the delivery method page
				 */
				return redirect("/delivery-method");
			}

			return next();
		}

		// if (to.name === routeMapper.routeNames.DeliveryMethod && shopSelected && deliveryMethodSelected) {
		// 	return next();
		// }
	};

	if (store.getters.featureToggles.moveRestaurantAndDeliveryMethodToAppInitiation) {
		if(from === "/") {
			store.commit(mutationTypes.SET_FOLLOW_STANDARD_PRODUCT_CATALOG_FLOW, false);
		}
		if (channel === "mobileBrowser") {
			await shopAndDeliveryMethodFlow();
		}

		if (appConfig.mobile.isMobileApp() && hasAppDownloaded === "1" && !localStorage.getItem("skipRedirectToShopSelection")) {
			await shopAndDeliveryMethodFlow();
		}
		localStorage.removeItem("skipRedirectToShopSelection");
	}

	// fetch pick up rules if not fetched for any reason
	// example user forcefully refreshes the page
	if (
		!(store.getters.cachedPickupRules || []).length &&
		(
			[from.name, to.name].includes(routeMapper.routeNames.productCatalog) ||
			[from.name, to.name].includes(routeMapper.routeNames.checkoutCart)
		)
	) {
		await store.dispatch(mutationTypes.FETCH_AND_CACHE_PICKUP_RULES, {
			forceRefresh: true
		});
	}

	await successCallback();
	return redirect(successUrl);
};

export default {
	routes: [
		{
			path: "/",
			name: routeMapper.routeNames.Home,
			component: HomeWrapper,
			beforeEnter: obsoleteVersionRedirect()
		},
		{
			path: "/obsolete-version",
			name: routeMapper.routeNames.obsoleteVersion,
			component: VersionUpdatePage
		},
		{
			path: "/devSupport",
			name: routeMapper.routeNames.DevSupport,
			component: DevSupport

		},
		{
			path: "/map",
			name: routeMapper.routeNames.Map,
			component: Map

		},
		{
			path: "/game",
			name: routeMapper.routeNames.GamePage,
			component: GamePage

		},
		{
			path: "/category/:categoryId",
			name: routeMapper.routeNames.productCatalog,
			component: ProductCatalog,
			beforeEnter: obsoleteVersionRedirect(),
			props: true
		},
		{
			path: "/delivery-method",
			name: routeMapper.routeNames.DeliveryMethod,
			component: ShoppingCartStepDeliveryMethod,
			beforeEnter: obsoleteVersionRedirect()
		},
		{
			path: "/delivery-address",
			name: routeMapper.routeNames.deliveryAddress,
			component: AddressDeliveryWrapper
		},
		{
			path: "/address-selection",
			name: routeMapper.routeNames.DeliveryAddressPicker,
			component: UserAddressWrapper
		},
		{
			path: "/checkout",
			name: routeMapper.routeNames.checkoutCart,
			component: ShoppingCart,
			beforeEnter: obsoleteVersionRedirect()
		},
		{
			path: "/full-basket-checkout",
			name: routeMapper.routeNames.fullBasketCheckout,
			component: FullBasketCheckout,
			beforeEnter: obsoleteVersionRedirect()
		},
		{
			path: "/payment/:action",
			name: routeMapper.routeNames.payment,
			component: Payment,
			beforeEnter: (_to, _from, next) => {
				store.commit("RECOMPUTE_PRODUCT_CATALOG_CACHE", true);
				next();
			}
		},
		{
			path: "/pending-order",
			name: routeMapper.routeNames.pendingOrder,
			component: PendingOrderWrapper,
			beforeEnter: obsoleteVersionRedirect({
				successUrl: "/",
				pendingUrl: null
			})
		},
		{
			path: "/shop-selection",
			name: routeMapper.routeNames.shopSelection,
			component: GlobalShopSelection,
			beforeEnter: obsoleteVersionRedirect({
				successCallback: () => store.commit("RECOMPUTE_PRODUCT_CATALOG_CACHE", true)
			})
		},
		{
			path: "/user-profile",
			name: routeMapper.routeNames.userProfile,
			component: UserProfilePage,
			beforeEnter: obsoleteVersionRedirect()
		},
		{
			path: "/sign-up",
			name: routeMapper.routeNames.SignUp,
			component: SignUp,
			beforeEnter: obsoleteVersionRedirect()
		},
		{
			path: "/subscription-finished",
			name: routeMapper.routeNames.SubscriptionFinished,
			component: SubscriptionFinished
		},
		{
			path: "/profile",
			name: routeMapper.routeNames.Profile,
			component: ProfilePage
		},
		{
			path: "/user-data",
			name: routeMapper.routeNames.userData,
			component: UserDataPage
		},
		{
			path: "/table-serving",
			name: routeMapper.routeNames.tableServing,
			component: TableServing
		},
		{
			path: "/check-email",
			name: routeMapper.routeNames.CheckEmail,
			component: CheckEmail
		},
		{
			path: "/feedback",
			name: routeMapper.routeNames.feedback,
			component: UserFeedback
		},
		{
			path: "/feedback-completed",
			name: routeMapper.routeNames.feedbackCompleted,
			component: FeedbackCompleted
		},
		{
			path: "/initialize-subscription",
			name: routeMapper.routeNames.InitializeSubscription,
			component: InitializeSubscription,
			beforeEnter: (to, from, next) => {
				if (to.query.error) {
					if (!store.getters.personData) {
						return next("/");
					}

					if (store.getters.personData.firstName) {
						return next("/sign-up");
					}

					return next("/check-email?flow=subscription");
				}
				next();
			}
		},
		{
			path: "/subscribe/:membership",
			name: routeMapper.routeNames.SetMembership,
			component: SubscriptionPlans,
			beforeEnter: obsoleteVersionRedirect()
		},
		{
			path: "/subscription-plans",
			name: routeMapper.routeNames.subscriptionPlans,
			component: SubscriptionPlans,
			beforeEnter: obsoleteVersionRedirect()
		},
		{
			path: "/user-orders-list",
			name: routeMapper.routeNames.UserOrdersList,
			component: UserOrdersList,
			beforeEnter: obsoleteVersionRedirect()
		},
		{
			path: "/user-order-details/:orderId",
			name: routeMapper.routeNames.UserOrderDetails,
			component: UserOrderDetails,
			beforeEnter: obsoleteVersionRedirect()
		},
		{
			path: "/subscription-qr-code",
			name: routeMapper.routeNames.SubscriptionScannerCode,
			component: () => import("../../components/ShopComponents/gt2/Subscriptions/SubscriptionScannerCodeWrapper-gt2"),
			beforeEnter: obsoleteVersionRedirect()
		},
		{
			path: "/accept-subscription-terms",
			name: routeMapper.routeNames.AcceptSubscriptionTerms,
			component: AcceptSubscriptionTerms
		},
		{
			path: "/accept-sunsetpoints-terms",
			name: routeMapper.routeNames.AcceptSunsetPointsTerms,
			component: AcceptSunsetPointsTerms
		},
		{
			path: "/terms-conditions",
			name: routeMapper.routeNames.TradingConditions,
			component: TradingConditions
		},
		{
			path: "/subscription-plan-cancel",
			name: routeMapper.routeNames.SubscriptionPlanCancel,
			component: SubscriptionPlanCancel
		},
		{
			path: "/subscription-cancel-feedback",
			name: routeMapper.routeNames.SubscriptionCancelFeedback,
			component: SubscriptionCancelFeedback
		},
		{
			path: "/subscription-payment-failed",
			name: routeMapper.routeNames.SubscriptionPaymentFailed,
			component: SubscriptionPaymentFailed
		},
		{
			path: "/subscription-payment-done",
			name: routeMapper.routeNames.SubscriptionPaymentDone,
			component: SubscriptionPaymentDone
		},
		{
			path: "/about-sunset-to-go",
			name: routeMapper.routeNames.AboutSunsetToGo,
			component: AboutSunsetToGo
		},
		{
			path: "/subscription-invoices",
			name: routeMapper.routeNames.SubscriptionInvoices,
			component: SubscriptionInvoices
		},
		{
			path: "/catalogPagePreview",
			name: routeMapper.routeNames.catalogPagePreview,
			component: CatalogPagePreview,
			beforeEnter: (_to, _from, next) => {
				store.commit("RECOMPUTE_PRODUCT_CATALOG_CACHE", true);
				next();
			}
		},
		{
			path: "/booth-number",
			name: routeMapper.routeNames.boothNumber,
			component: ShoppingCartDriveInBoothNumber,
			beforeEnter: (to, from, next) => {
				const deliveryChoice = (store.getters.tenantSpecificData || {}).deliveryChoice;
				if (deliveryChoice === DeliveryMethodsEnum.DRIVE_IN) {
					next();
				} else {
					next({ name: routeMapper.routeNames.Home });
				}
			}
		},
		{
			path: "/drive-in-details-via-qr-code",
			name: routeMapper.routeNames.driveInDetailsViaQrCode,
			component: ShoppingCartDriveInDetailsViaQrCode
		},
		{
			path: "/eat-in-details-via-qr-code",
			name: routeMapper.routeNames.eatInDetailsViaQrCode,
			component: ShoppingCartEatInDetailsViaQrCode
		},
		{
			path: "/country-language-selection",
			name: routeMapper.routeNames.countryLanguageSelectionScreen,
			component: CountryLanguageSelectionScreen
		},
		{
			path: "/nutritional-information/:productId",
			name: routeMapper.routeNames.nutritionalInformation,
			component: NutritionalInformation,
			props: true
		},
		{
			path: "/notifications",
			name: routeMapper.routeNames.notifications,
			component: UserNotificationsListPage
		},
		{
			path: "/notifications/:id",
			name: routeMapper.routeNames.notificationDetails,
			component: UserNotificationDetailsPage,
			props: route => ({query: route.query})
		},
		{
			path: "/friend-invite",
			name: routeMapper.routeNames.friendInvite,
			component: FriendInvitePage
		},
		{
			path: "/reordering-mode",
			name: routeMapper.routeNames.previousOrdersReordering,
			component: UserReorderList
		},
		{
			path: "/milestone-reward",
			name: routeMapper.routeNames.milestoneReward,
			component: MilestoneReward
		},
		{
			path: "/milestone-reward-details",
			name: routeMapper.routeNames.milestoneRewardDetails,
			component: MilestoneRewardDetails
		},
		{
			path: "/discount",
			name: routeMapper.routeNames.discount,
			component: Discount
		},
		{
			path: "/language",
			name: routeMapper.routeNames.countryLanguage,
			component: CountryLanguage
		},
		{
			path: "/redirect-helper",
			name: routeMapper.routeNames.redirectHelper,
			component: RedirectHelper
		},
		{
			path: "/point-overview",
			name: routeMapper.routeNames.pointOverview,
			component: PointOverview
		},
		{
			path: "/subscription-upgrade-downgrade",
			name: routeMapper.routeNames.subscriptionUpgrade,
			component: SubscriptionUpgradeDowngrade
		},
		{
			path: "/select-subscription",
			name: routeMapper.routeNames.selectSubscription,
			component: SelectSubscription
		},
		{
			path: "/select-payment-plan",
			name: routeMapper.routeNames.selectPaymentPlan,
			component: SelectPaymentPlan
		},
		{
			path: "/subscription-upgrade-select-plan",
			name: routeMapper.routeNames.selectSubscriptionPlan,
			component: SubscriptionUpgradeSelectPlan
		}
	]
};
